import instance from "../components/general/AxiosInterceptor";
const controller = "/api/subscription";

export const searchSubscriptionsApi = (payload) => {
  return instance.post(`${controller}/search`, payload);
};

export const searchNewSubscriptionsApi = (payload) => {
  return instance.post(`${controller}/search/new`, payload);
};

export const createNewSubscriptionApi = () => {
  return instance.post(`${controller}/new`, {});
}

export const searchNouvelSubscriptionsApi = async (body, params) => {
  const response = await instance.post(`${controller}/nouvel-demandes?page=${params.page}&size=${params.pageSize}`, { ...body }); 
  return response.data?.body;
};

export const searchPendingSubscriptionsApi = async (body, params) => {
  const response = await instance.post(`${controller}/pending-demandes?page=${params.page}&size=${params.pageSize}`, { ...body }); 
  return response.data?.body;
};

export const searchClotureSubscriptionsApi = async (body, params) => {
  const response = await instance.post(`${controller}/cluture-demandes?page=${params.page}&size=${params.pageSize}`, { ...body }); 
  return response.data?.body;
};

export const searchEnProcessSubscriptionsApi = async (body, params) => {
  const response = await instance.post(`${controller}/en-progress-demandes?page=${params.page}&size=${params.pageSize}`, { ...body }); 
  return response.data?.body;
};



export const autoAffectationApi = (subscriptionId) => {
  return instance.post(`${controller}/auto_assign/${subscriptionId}`, {});
}

export const startWorkflowApi = (subscriptionId) => {
  return instance.post(`${controller}/start_workflow/${subscriptionId}`, {});
}

export const validateSubscriptionApi = (subscriptionId) => {
  return instance.post(`${controller}/validate/${subscriptionId}`, {});
}

export const affectationApi = (body) => {
  return instance.post(`${controller}/assign`, { ...body });
}

export const getSubscriptionByReferenceApi = async (reference) => {
  const response = await instance.get(`${controller}/subscription-details/${reference}`); 
  return response.data.body;
};

export const acceptSubscriptionApi = (subscriptionId) => {
  return instance.post(`${controller}/accept/${subscriptionId}`, {});
}

export const rejectSubscriptionApi = (body) => {
  return instance.post(`${controller}/reject`, { ...body });
}

export const getSubscriptionComplementApi = async () => {
  const response = await instance.post(`${controller}/pending-complement`); 
  return response.data.body;
};

export const getSubscriptionHistoryApi = async (subscriptionId) => {
  const response = await instance.get(`${controller}/${subscriptionId}/historique`);
  return response.data;
};